var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"question-view-dialog hotspot"},[_c('div',{staticClass:"quest"},[_c('div',{staticClass:"title"},[_c('vue-mathjax',{attrs:{"formula":_vm.form.title,"safe":false}})],1)]),_c('div',{staticClass:"quest-img-dialog",style:({backgroundImage: `url(${_vm.form.img_url || _vm.form.imgUrl})`})})])
}
var staticRenderFns = []

export { render, staticRenderFns }